class CtxCTabContentService {
    constructor($timeout) {
        this.$timeout = $timeout;
    }

    customAnimation(innerContent, panelElement) {
        panelElement.css({overflow: 'hidden'});
        this.$timeout(()=> {
            panelElement.animate({height: innerContent[0].getBoundingClientRect().height}, 200, () => {
                panelElement.css({height: 'auto'});
                panelElement.css({overflow: 'visible'});
            });
        },0);
    }
}

CtxCTabContentService.$inject = ['$timeout'];

module.exports = CtxCTabContentService;



// WEBPACK FOOTER //
// ./src/shared/ctxTabs/ctxTabContent.service.js